/* global axios */
import ApiClient from './ApiClient';

const BASE_URL = 'https://primary-tccw-staging.up.railway.app/webhook';

class RagAPI extends ApiClient {
  /**
   * Upload un fichier vers le webhook pour vectorisation
   * @param {File} file - Le fichier à uploader
   * @param {string} userId - UUID de l'utilisateur
   * @returns {Promise}
   */
  // eslint-disable-next-line class-methods-use-this
  uploadFile(file, userId) {
    const formData = new FormData();
    formData.append('file', file);

    return axios({
      method: 'POST',
      url: `${BASE_URL}/upload_file_k2o`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        user_id: userId,
      },
    });
  }

  /**
   * Récupérer toutes les catégories disponibles
   * @param {string} userId - UUID de l'utilisateur
   * @returns {Promise}
   */
  // eslint-disable-next-line class-methods-use-this
  getAllCategories(userId) {
    return axios({
      method: 'GET',
      url: `${BASE_URL}/k2o_categories`,
      headers: {
        user_id: userId,
      },
    });
  }

  /**
   * Récupérer les fichiers par catégorie
   * @param {string} categoryName - Nom de la catégorie
   * @param {string} userId - UUID de l'utilisateur
   * @returns {Promise}
   */
  // eslint-disable-next-line class-methods-use-this
  getFilesByCategory(categoryName, userId) {
    return axios({
      method: 'GET',
      url: `${BASE_URL}/4067b6a6-4cf2-4129-8d2f-0e67932d9ff1/k2o_categories/${categoryName}`,
      headers: {
        user_id: userId,
      },
    });
  }

  /**
   * Rechercher par mots-clés
   * @param {string} keyword - Mot-clé à rechercher
   * @param {string} userId - UUID de l'utilisateur
   * @returns {Promise}
   */
  // eslint-disable-next-line class-methods-use-this
  searchByKeyword(keyword, userId) {
    return axios({
      method: 'POST',
      url: `${BASE_URL}/k2o_categories/keywords`,
      data: { keyword },
      headers: {
        'Content-Type': 'application/json',
        user_id: userId,
      },
    });
  }
}

export default new RagAPI();
